import { render, staticRenderFns } from "./GerenciaRelatorioAlunos.vue?vue&type=template&id=16a96fb2"
import script from "./GerenciaRelatorioAlunos.vue?vue&type=script&lang=js"
export * from "./GerenciaRelatorioAlunos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports